<template>
  <div>

    <el-table
        :data="tableData"
        class="history-table"
    >
      <el-table-column label="Название" prop="title">

      </el-table-column>
      <el-table-column label="Кол-во отклонений" prop="sum" align="right">

      </el-table-column>
      <el-table-column label="Версия" prop="version" width="100" align="right">

      </el-table-column>

      <el-table-column label="Время записи" prop="date" align="right">

      </el-table-column>


    </el-table>

  </div>
</template>

<script>
export default {
  name: 'RecognitionLog',
  data() {
    return {
      tableData: [
        {
          title: 'Термограмма №1235468 загруженна оператором',
          sum: '10 отклонений',
          version: 'v.1.0.0',
          date: '07.06.21'
        },
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/zebra-table.scss";

.history-table {
  margin-top: 16px;
  width: 100%;
}
</style>